import UserForm from '../component/form/userForm'
import { v4 as uuidv4 } from 'uuid'
import TenantForm from '../component/form/TenantForm'
import { Dialog, DialogTitle, DialogContent, Typography } from '@mui/material'


const TenantModal = (props) =>{



  const submit = (params)=>{
    if(!params.id){
      params.id = uuidv4();
    }
    props.datafunc(params);
    close();
  }

  const close = () => {
    props.setOpen(false);
  }

  return (
    <>
      <Dialog open={props.open} onClose={close} sx={{}}>
        <DialogTitle><Typography variant={'body'} >新規テナント登録</Typography></DialogTitle>
        <DialogContent>
          <TenantForm process={submit} cancel={close} data={props.data}/>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default TenantModal